import { render, staticRenderFns } from "./SortReally.vue?vue&type=template&id=08bc8707&scoped=true&"
import script from "./SortReally.vue?vue&type=script&lang=js&"
export * from "./SortReally.vue?vue&type=script&lang=js&"
import style0 from "./SortReally.vue?vue&type=style&index=0&id=08bc8707&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc8707",
  null
  
)

export default component.exports